<template>
  <div class>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      :property-mapping="createErrorPropertyMappings()"
    />
    <u-loader v-if="isLoading" />
    <div v-else-if="currentEdition">
      <form
        style="position: relative"
        @submit.prevent="saveContractVersionEdition"
      >
        <button
          v-if="!editMode && canUserEdit"
          v-b-tooltip.hover
          class="btn btn-primary"
          placement="bottom"
          style="position: absolute; top: 0; right: 0; z-index: 1"
          title="Editionsdetails bearbeiten"
          type="button"
          @click="editMode = !editMode"
        >
          <i class="fas fa-edit" />
        </button>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label class="pl-0 col-3 defaultLabel">Kantone</label>
              <div class="form-check col-9 pl-0">
                <div class="mr-4">
                  {{ cantons }}
                </div>
              </div>
            </b-row>
          </b-container>
        </div>

        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                :for="currentEdition.vertragsdatenVisible"
                class="pl-0 col-3 defaultLabel"
              >GAV-Details anzeigen</label>
              <div class="form-check col-9 pl-0">
                <label>
                  <input
                    v-model="currentEdition.vertragsdatenVisible"
                    :disabled="!editMode"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text" />
                </label>
                <u-validation-checker
                  v-if="editMode"
                  v-model="requiredProperties"
                  :is-empty="false"
                  :section="validationSection"
                  property-name="vertragsdatenVisible"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                :for="currentEdition.lohnrechnerVisible"
                class="pl-0 col-3 defaultLabel"
              >Lohnrechner anzeigen</label>
              <div class="form-check col-9 pl-0">
                <label>
                  <input
                    v-model="currentEdition.lohnrechnerVisible"
                    :disabled="!editMode"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text" />
                </label>
                <u-validation-checker
                  v-if="editMode"
                  v-model="requiredProperties"
                  :is-empty="false"
                  :section="validationSection"
                  property-name="lohnrechnerVisible"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                :for="currentEdition.uelVisible"
                class="pl-0 col-3 defaultLabel"
              >Üblicher Lohn anzeigen</label>
              <div class="form-check col-9 pl-0">
                <label>
                  <input
                    v-model="currentEdition.uelVisible"
                    :disabled="!editMode"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text" />
                </label>
                <u-validation-checker
                  v-if="editMode"
                  v-model="requiredProperties"
                  :is-empty="false"
                  :section="validationSection"
                  property-name="uelVisible"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <!-- Zuschlagsrechner anzeigen-->
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                class="pl-0 col-3 defaultLabel"
              >Zuschlagsrechner anzeigen</label>
              <div class="form-check col-9 pl-0">
                <label>
                  <input
                    v-model="currentEdition.supplementCalculatorVisible"
                    :disabled="!editMode"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text" />
                </label>
                <u-validation-checker
                  v-if="editMode"
                  v-model="requiredProperties"
                  :is-empty="false"
                  :section="validationSection"
                  property-name="uelVisible"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                :for="currentEdition.komentar"
                class="pl-0 col-3 defaultLabel"
              >Kommentar zur Edition</label>
              <div
                v-if="!editMode"
                class="col-9 pl-0"
              >
                <span
                  v-if="currentEdition.komentar != ''"
                  class="whitespace-preline"
                >{{ currentEdition.komentar }}</span>
                <span v-else>-</span>
              </div>
              <div
                v-else
                class="col-9 pl-0"
              >
                <v-flex sm12>
                  <v-textarea
                    v-model="currentEdition.komentar"
                    :auto-grow="true"
                    :rows="1"
                    label="Kommentar"
                  />
                </v-flex>
                <u-validation-checker
                  v-model="requiredProperties"
                  :is-empty="!currentEdition.komentar"
                  :section="validationSection"
                  property-name="komentar"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div
          v-if="editMode"
          class="buttonContainer pt-4"
        >
          <b-button
            :disabled="requiredProperties.length != 0"
            name="saveVersionEditionDetails"
            type="submit"
            variant="success"
          >
            Speichern
          </b-button>
          <b-button
            class="ml-2"
            variant="danger"
            @click="LoadAllEditions()"
          >
            Abbrechen
          </b-button>
        </div>
      </form>
    </div>
    <h4 class="mt-4">
      Editionen
    </h4>
    <!-- This has changed a million times :(, and I thinkg it might change again in the future. Future Dev, are you sure you want to do this? -->
    <!-- OLD: might be used again: Check that last edition's editior is not the current user (and the current state is not published), or any edition in the version is not deactivated
      v-if="contractEditions.filter(edition => { return edition.stateId == 5}).length <= 0 && !(contractEditions[0].stateId != 3 && contractEditions[0].ownerPrincipal == $GetCurrentUserName())" -->
    <!-- CURRENT: No Edition can be deactivated in the version to create a new Edition and the user needs to be in the Role "Sachbearbeiter" -->
    <edition-create-new
      v-if="
        contractEditions.filter((edition) => {
          return edition.stateId == 5;
        }).length <= 0 &&
          ($IsUserInRole('VertragsmanagementVerwaltung') ||
          ($IsUserInRole('VertragsmanagementUniaVertragsverantworlich') &&
          canUniaVerantwortlicheEdit === true))
      "
      :contract-id="contractId"
      :edition-id="currentEditionId"
      :version-number="versionId"
      class="float-right"
      @newEditionCreated="LoadAllEditions"
    />
    <edition-history
      :all-editions="contractEditions"
      :contract-id="contractId"
      :current-edition-id="currentEditionId"
      :version-id="versionId"
      :version-id-id="versionIdId"
      @editionsChanged="LoadAllEditions"
    />
  </div>
</template>

<script>
import {
  GetAllEditions,
  GetSinlgeEdition,
  SaveEditionInformation,
} from "@/services/contract.edition.service.js";

import { GetCantons } from "@/services/contract.edition.cantons.service.js";
import EditionHistory from "@/components/contract/edition/EditionHistory.vue";
import EditionCreateNew from "@/components/contract/edition/EditionCreateNew.vue";

export default {
  components: {
    EditionHistory,
    EditionCreateNew,
  },
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    versionIdId: {
      type: Number,
      default: 0,
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validationSection: "Edition",
      errorObject: null,
      isLoading: false,
      contractEditions: [],
      currentEditionId: null,
      currentEdition: null,
      editMode: false,
      cantons: [],
      requiredProperties: [],
    };
  },
  computed: {
    canUniaVerantwortlicheEdit() {
      if (this.$store.state.adminCurrentContract.VersionData?.ave) {
        if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState != 0
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState ==
            0 &&
          this.$store.state.adminCurrentContract.VersionData.anhang1 === true
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState ==
            0 &&
          this.$store.state.adminCurrentContract.VersionData.anhang1 === false
        ) {
          return true;
        }
      }

      if (!this.$store.state.adminCurrentContract.VersionData) {
        return true;
      }
      if (!this.$store.state.adminCurrentContract.VersionData.ave) {
        if (
          this.$store.state.adminCurrentContract.VersionData.anhang1 === true
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.anhang1 === false
        ) {
          return true;
        }
      }

      return false;
    },
  },

  created() {
    this.LoadAllEditions();
  },
  methods: {
    createErrorPropertyMappings() {
      var mapping = {};
      return mapping;
    },
    loadAllCantons() {
      this.isLoading = true;
      this.errorObject = null;

      GetCantons(
        this.contractId,
        this.versionId,
        this.currentEditionId,
        (response) => {
          this.isloading = false;
          this.cantons = "";

          if (response.length == 26) {
            this.cantons = "Alle Kantone";
          } else {
            response.map((canton) => {
              this.cantons += canton.value + ", ";
            });

            this.cantons =
              this.cantons != ""
                ? this.cantons.substring(0, this.cantons.length - 2)
                : "keine";
          }
        },
        (error) => {
          this.isloading = false;
          this.errorObject = error;
        },
      );
    },
    LoadAllEditions() {
      this.isLoading = true;
      this.errorObject = null;

      GetAllEditions(
        this.contractId,
        this.versionId,
        (response) => {
          this.contractEditions = response;
          this.isLoading = false;

          if (this.contractEditions && this.contractEditions.length > 0) {
            if (this.$route.params.editionId) {
              this.currentEditionId = parseInt(
                this.$route.params.editionId,
                10,
              );

              var specificEdition = this.contractEditions.filter((edition) => {
                return (
                  edition.editionId.toString() == this.$route.params.editionId
                );
              });

              if (specificEdition.length == 1) {
                this.$emit(
                  "currentEditionLoaded",
                  specificEdition[0],
                  this.contractEditions[0] == specificEdition[0],
                );
              } else {
                this.$emit(
                  "currentEditionLoaded",
                  this.contractEditions[0],
                  true,
                );
              }
            } else {
              this.currentEditionId = this.contractEditions[0].editionId;
              this.$emit(
                "currentEditionLoaded",
                this.contractEditions[0],
                true,
              );
            }

            this.$store.commit("setAdminCurrentEditions", response);

            this.LoadCurrentEdition(this.currentEditionId);
          }

          this.loadAllCantons();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );

      this.editMode = false;
    },
    LoadCurrentEdition(editionId) {
      this.errorObject = null;
      this.isLoading = true;

      GetSinlgeEdition(
        this.contractId,
        this.versionId,
        editionId,
        (response) => {
          this.currentEdition = response;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    saveContractVersionEdition() {
      this.errorObject = false;

      SaveEditionInformation(
        this.currentEdition,
        this.contractId,
        this.versionId,
        (updatedEdition) => {
          this.contract = updatedEdition;
          this.editMode = false;
          this.isLoading = false;
          this.LoadCurrentEdition(this.currentEditionId);
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style scoped>
.form-group {
  font-size: initial;
}

.card-title {
  margin-top: 10px;
}

.whitespace-preline {
  white-space: pre-line;
}
</style>
